import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';
//
export function transComLevel(level) {
    if(Utils.isNoB(level)) {
        return '';
    }
    let comLevel = '';
    switch(level) {
        case 1:
            comLevel = '一级';
            break;
        case 2:
            comLevel = '二级';
            break;
        case 3:
            comLevel = '三级';
            break;
        case 4:
            comLevel = '四级';
            break;
        case 5:
            comLevel = '五级';
            break;
        case 6:
            comLevel = '六级';
            break;
        case 7:
            comLevel = '七级';
            break;
        case 8:
            comLevel = '八级';
            break;
        case 9:
            comLevel = '九级';
            break;
        case 10:
            comLevel = '十级';
            break;
    }
    return comLevel;
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/orgStruct/struct-comn.js
// module id = 231
// module chunks = 1